/**
 * Returns the first day of the week using an Intl compatible numbering system.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo#firstday
 * MON = 1
 * SUN = 7
 *
 * See compatibility table implementation notes for reasoning around different property accesses.
 */ export function getIntlFirstWeekday(localeString) {
    var _global_Intl, _locale_getWeekInfo;
    if (!((_global_Intl = global.Intl) === null || _global_Intl === void 0 ? void 0 : _global_Intl.Locale)) return 1;
    var locale = new Intl.Locale(localeString);
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo
    // @ts-expect-error
    var weekInfo = ((_locale_getWeekInfo = locale.getWeekInfo) === null || _locale_getWeekInfo === void 0 ? void 0 : _locale_getWeekInfo.call(locale)) || locale.weekInfo;
    var _weekInfo_firstDay;
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo#firstday
    // 1 = MON, 7 = SUN
    return (_weekInfo_firstDay = weekInfo === null || weekInfo === void 0 ? void 0 : weekInfo.firstDay) !== null && _weekInfo_firstDay !== void 0 ? _weekInfo_firstDay : 7;
}
/**
 * Returns the first day of the week with a value compatible with Date.getDay
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getDay
 * SUN = 0
 * MON = 1
 */ export function getIntlFirstWeekdayAsDateDay(localeString) {
    var firstWeekday = getIntlFirstWeekday(localeString);
    return [
        null,
        1,
        2,
        3,
        4,
        5,
        6,
        0
    ][firstWeekday];
}
